import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import '../../../../node_modules/react-grid-layout/css/styles.css';
import '../../../../node_modules/react-resizable/css/styles.css';
import { WidthProvider, Responsive } from "react-grid-layout";
import axios from 'axios';
import _ from "lodash";
var redirectURL = require('../../redirectURL');

export default class OnTimeDeliver extends Component{

	constructor(props)
	{
		super(props);
		this.state={
            legs:'',
			userid:localStorage.getItem('userid'),
		};
		
    }
    componentDidMount(){
        var formdata = {
            userid:this.state.userid,
            kpitype:'ontimedeliver'
        };
        redirectURL.post('/manage/kpiConfigurations',formdata, {
            headers:{
                'Content-type':'application/json'
            }
        })
        .then((response) => {
            console.log(response.data);
            if(response.data.length > 0)
            {
                this.setState({
                    legs:response.data[0].legs
                });
            }
        })
    }
    changeInputHandler = (event) => {
        const re = /^[0-9\\:\b]+$/;
        if(re.test(event.target.value))
        {
            let name = event.target.name;
            let value = event.target.value;
            this.setState({[name]:value});
        }
    }
	formHandler = (event) => {
        event.preventDefault();
        var formdata = {
            userid:this.state.userid,
            dept_code:"LOG-PRT",
            kpitype:"ontimedeliver",
            legs:this.state.legs
        }
        console.log(formdata)
        redirectURL.post('/manage/saveKPIConfigurations',formdata, {
            headers:{
                'Content-type':'application/json'
            }
        })
        .then((response) => {
            var res = response.data;
            if(res.result.result.ok == 1)
            {
                this.props.context.showAlert();
            }
            else{
                this.props.context.showErrorAlert();
            }
        })
    }
	 render() {
        return (
            <div className="row">
                <div className="col-xl-12 col-lg-12">
                    <h5>On Time Deliver</h5>
                </div>
                <form className=" theme-form col-xl-6 col-lg-6" onSubmit={this.formHandler}>
                    <div className="col-xl-12 col-lg-12">
                        <div className="form-group">
                            <label className="c-lbl">No of Legs *:</label>
                            <input type="text" name="legs" value={this.state.legs} onChange={this.changeInputHandler.bind(this)} className="form-control" placeholder="No of Legs" />
                        </div>
                    </div>
                    <div className="form-group">
                        <button type="submit" className="btn btn-success cs-btn" id="save">Save</button>
                    </div>
                </form>
            </div>
        );
    }
}

